import React from 'react';
import { Link } from 'react-router-dom';
import RightGreenCheckMark from '../../../assets/images/right-green-check-mark.svg';
import { AuthRoutes, NonAuthRoutes } from '../../../enums';
import Button from '../../DesignSystem/button';
import AuthRoute from '../../Auth/AuthRoute';

const SuccessSection: React.FC = () => {
  return (
    <div className="success-root">
      <img src={RightGreenCheckMark} alt="Checkmark" />
      <h6>Thank you for requesting a private node.</h6>
      <p>We will notify you with further instructions. You can check the status of your request in the "View Private Node Status" page.</p>
      <div className="buttons">
        <Link to={AuthRoutes.dashboard}><Button className="login-btn-reg" variant="success" node="DashBoard" /></Link>
      </div>
    </div>
  );
};

export default SuccessSection;
